import { motion } from 'framer-motion';

export default function PreFooter() {
  const WA_LINK = 'https://wa.me/5576737753?text=Hola%2C%20me%20gustar%C3%ADa%20solicitar%20mi%20clase%20gratis%20en%20Larghetto.';

  return (
    <section className="relative bg-white py-24 md:py-36 px-4 overflow-hidden border-t border-gray-100">
      <div className="relative max-w-6xl mx-auto text-center">
        {/* Ticker de campus */}
        <div className="overflow-hidden mb-12" aria-hidden="true">
          <div className="animate-marquee inline-flex items-center gap-8 whitespace-nowrap">
            {[...Array(8)].map((_, i) => (
              <span key={i} className="inline-flex items-center gap-8">
                <span className="text-sm font-bold tracking-[0.3em] uppercase text-gray-400">CDMX</span>
                <span className="text-gray-300 leading-none">•</span>
                <span className="text-sm font-bold tracking-[0.3em] uppercase text-gray-400">CUAUTLA</span>
                <span className="text-gray-300 leading-none">•</span>
                <span className="text-sm font-bold tracking-[0.3em] uppercase text-gray-400">CUERNAVACA</span>
                <span className="text-gray-300 leading-none">•</span>
              </span>
            ))}
          </div>
        </div>


        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-black leading-none tracking-tight mb-8"
        >
          SOMOS MÁS QUE
          <br />
          SOLO MÚSICA
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-gray-400 text-sm mb-12"
        >
          contacto@larghetto.com.mx
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
        >
          <a
            href={WA_LINK}
            target="_blank"
            rel="noreferrer"
            className="inline-block px-10 py-5 rounded-full font-bold text-black text-sm tracking-widest uppercase
                       transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-yellow-400/50"
            style={{ background: 'linear-gradient(135deg, #FFE033, #FFB800)' }}
          >
            Solicita tu Clase Gratis
          </a>
        </motion.div>
      </div>
    </section>
  );
}
